
import {
  defineComponent,
  reactive,
  UnwrapRef,
  computed,
  PropType,
  watch,
} from 'vue';
import { definitions } from '@/types/api';
import { cloneDeep } from 'lodash';
import {
  Table,
  Input,
  Button,
  Popconfirm,
  InputNumber,
  DatePicker,
  Spin,
  message,
  Modal,
} from 'ant-design-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/add.svg';
import asynButtonVue from '@/components/asynButton.vue';

const component = defineComponent({
  name: 'team-table',
  components: {
    SvgIcon,
    aTable: Table,
    aInput: Input,
    aButton: asynButtonVue,
    aPopconfirm: Popconfirm,
    aInputNumber: InputNumber,
    aDatePicker: DatePicker,
    aSpin: Spin,
  },
  props: {
    teamList: {
      type: Array as PropType<definitions['CustomRoleTeam'][]>,
      require: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const columns = [
      {
        title: '队伍名称',
        dataIndex: 'teamName',
        key: 'teamName',
        width: '20%',
        slots: { customRender: 'teamName' },
      },
      {
        title: '队伍人数',
        dataIndex: 'peopleQuantity',
        key: 'peopleQuantity',
        width: '20%',
        slots: { customRender: 'peopleQuantity' },
      },
      {
        title: '队伍到达时间',
        dataIndex: 'arrivalTime',
        key: 'arrivalTime',
        width: '25%',
        slots: { customRender: 'arrivalTime' },
      },
      {
        title: '队伍救援能力',
        key: 'rescueCapability',
        dataIndex: 'rescueCapability',
        width: '20%',
        slots: { customRender: 'rescueCapability' },
      },
      {
        title: '操作',
        key: 'operation',
        width: '15%',
        slots: { customRender: 'operation' },
      },
    ];

    const dataSource = computed(() => props.teamList);

    const editableData: UnwrapRef<
      Record<string, definitions['CustomRoleTeam']>
    > = reactive({});

    const addBtnDisable = computed(() => dataSource.value.length >= 8);

    const edit = (key: string) => {
      editableData[key] = cloneDeep(
        dataSource.value.filter((item) => key === item.id)[0],
      );
    };

    const save = (key: string) => {
      if (editableData[key].teamName?.trim() === '') {
        message.error('请填写队伍名称');
      } else {
        context.emit('saveTeam', { id: key, item: editableData[key] });

        delete editableData[key];
      }
    };

    const cancel = (
      key: string,
      record: definitions['CustomRoleTeam'],
      index: number,
    ) => {
      if (record.teamName?.trim() === '') {
        context.emit('delTeam', { id: record.id, index });
      }

      delete editableData[key];
    };

    const add = () => {
      context.emit('addTeam');

      const teamId = dataSource.value[dataSource.value.length - 1].id || '';
      edit(teamId);
    };

    const del = (id: string, index: number) => {
      Modal.confirm({
        content: '确认删除？',
        onOk: async () => {
          context.emit('delTeam', { id, index });
        },
      });
    };

    watch(
      () => editableData,
      (keys) => {
        if (JSON.stringify(keys) === '{}') {
          context.emit('changeSaveStatusCheck', false);
          console.log('changeSaveStatusCheck1');
        } else {
          context.emit('changeSaveStatusCheck', true);
          console.log('changeSaveStatusCheck2');
        }
      },
      { deep: true, immediate: true },
    );

    return {
      props,
      columns,
      dataSource,
      editableData,
      addBtnDisable,
      edit,
      save,
      cancel,
      add,
      del,
    };
  },
});

export default component;
